import { request } from "./http";

export interface AppropriatenessOption {
  label: string;
  score: number;
}

export interface AppropriatenessQuestion {
  id: string;
  category: "knowledge" | "experience" | "financial";
  prompt: string;
  options: AppropriatenessOption[];
}

export interface AppropriatenessState {
  questions: AppropriatenessQuestion[];
  latest_total_score: number | null;
  latest_completed_at: string | null;
  leverage_unlock_max: number;
}

export const appropriateness = {
  current: () => request<AppropriatenessState>("/api/v1/me/appropriateness"),
  submit: (answers: { question_id: string; option_index: number }[]) =>
    request<AppropriatenessState>("/api/v1/me/appropriateness", {
      body: { answers },
    }),
};
